var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTplLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 117.84 60.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f2303a;}.cls-4{clip-path:url(#clippath-1);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 2.65,
    width: 111.67,
    height: 55.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 2.65,
    width: 111.67,
    height: 55.65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Red"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3.08,23.81l5.28-.65.34,2.75c.71-1.31,2.65-3.63,6.81-4.14,2.4-.29,5.17.28,7.05,1.7,1.59,1.24,3.58,3.61,4.18,7.8.41,3-.32,5.87-2.05,8.09-1.46,1.92-4.05,3.2-6.49,3.5-4.25.52-6.67-1.1-7.66-2.11l1.27,10.34-5.28.65-3.43-27.92Zm13.04,14.38l.26-.03c3.69-.45,5.61-2.87,5.17-6.51-.44-3.6-2.84-5.4-6.61-4.94l-.26.03c-3.73.46-5.62,2.82-5.17,6.51.44,3.6,2.84,5.4,6.61,4.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m70.23,33.36l1.49-12.14,5.23.64-1.44,11.71c-.36,2.96.99,4.74,3.9,5.09l.21.03c2.96.36,4.88-1.06,5.22-3.89l1.45-11.8,5.23.64-2.49,20.29-5.28-.65.31-2.49c-.96,1.06-3.08,2.71-6.46,2.3-6.22-.76-7.91-5.46-7.38-9.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m93.4,34c-1.21-9.82,6.16-11.86,9.34-12.25,3.47-.43,6.27.32,8.37,2.19,2.99,2.68,3.68,7.26,3.65,9.17l-15.87,1.95c.23,1.15.84,2.2,1.76,3.01,1.16.9,2.69,1.32,4.14,1.1l.26-.03c3.56-.44,4.4-3.15,4.4-3.15l5.23-.64s-.95,7.17-9.27,8.19c-2.36.29-10.84.02-12.01-9.54m15.78-4.07c-.19-1.2-.8-2.3-1.73-3.1-.97-.84-2.36-1.15-4.08-.94h-.04c-1.67.21-3.07.86-3.86,1.92-.75,1.01-1.08,2.22-1.02,3.43l10.72-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m34.58,13.09l.3.04c2.31.28,3.15,1.3,2.87,3.53-.31,2.53-1.71,2.92-3.68,2.68l-.3-.04c-2.36-.29-3.15-1.3-2.87-3.57.23-1.84.93-2.98,3.67-2.64m-3.67,8.99l5.27.65-2.49,20.28-5.27-.65,2.49-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m49.94,24.72c-1.58.71-.65,3.03.98,2.45,2.19-.88,4.88.16,5.95,2.26.36.7.56,1.48.57,2.27.09,1.72,2.58,1.69,2.64-.03.07-5.21-5.29-8.96-10.14-6.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m70.6,45.95l-5.68-5.68c1.69-2.43,2.67-5.39,2.67-8.59,0-8.27-6.64-14.99-14.84-14.99s-14.84,6.71-14.84,14.99,6.64,14.99,14.84,14.99c3.14,0,6.05-.98,8.45-2.66l5.68,5.68c.51.51,1.19.77,1.86.77s1.35-.26,1.86-.77c1.03-1.03,1.03-2.7,0-3.73m-27.25-14.27c0-5.24,4.21-9.49,9.4-9.49s9.4,4.25,9.4,9.49-4.2,9.49-9.4,9.49-9.4-4.25-9.4-9.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.76 4.9 41.76 5.14 41.57 3.58 47.32 2.87 47.51 4.44 45.5 4.68 46.44 12.39 44.71 12.6 43.76 4.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "49.17 2.65 50.92 2.65 50.92 6.37 54.8 6.37 54.8 2.65 56.56 2.65 56.56 11.99 54.8 11.99 54.8 8.04 50.92 8.04 50.92 11.99 49.17 11.99 49.17 2.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m59.3,2.96l4.63.57-.17,1.39-1.91-.23c-.72-.09-1.2.32-1.29,1.11-.11.93.43,1.33.99,1.4l1.75.21-.17,1.41-1.75-.21c-.73-.09-1.23.33-1.32,1.13-.08.62.15,1.34,1.01,1.44l1.91.23-.17,1.39-4.63-.57,1.14-9.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "79.01 48.22 80.71 48.43 79.75 56.18 82.67 56.54 82.48 58.05 77.87 57.49 79.01 48.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m87.16,48.97h2.15l3.35,9.34h-1.79l-.23-.63c-.13-.33-.28-.61-.52-.85-.45-.41-1.07-.61-1.83-.63h-.13c-.79.01-1.39.2-1.83.59-.28.24-.43.56-.56.85l-.25.67h-1.76l3.41-9.34Zm2.43,5.97l-1.36-4.25-1.39,4.25h2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m92.88,48.82l2.57-.32c1.05-.13,3.04-.12,3.29,1.91.23,1.84-1.47,2.31-1.47,2.31,0,0,2.51-.28,2.81,2.16.22,1.78-1.05,2.59-2.83,2.81l-3.24.4-1.14-9.27Zm3.21,3.37h.05c.81-.11,1.23-.62,1.13-1.41-.1-.8-.63-1.2-1.44-1.1h-.05c-.82.11-1.23.62-1.13,1.41.1.78.63,1.2,1.44,1.1m.74,4.27h.07c.94-.12,1.42-.72,1.31-1.62-.11-.91-.71-1.38-1.65-1.26h-.07c-.94.12-1.41.71-1.3,1.61.11.93.71,1.39,1.64,1.28"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTplLogo);
export default __webpack_public_path__ + "static/media/TPLLogo.f24feb168b32a70fa391fa930929716b.svg";
export { ForwardRef as ReactComponent };